import { Box, Grid, InfiniteScroll, Text } from '@factorialco/deprecated-design-system'
import { GetWorkSpacesWithBookingsQueryVariables } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'

import i18n from 'modules/core/lib/i18n'

import EmptySpace from 'modules/space_control/components/WorkSpacesList/EmptySpace'
import LoadingWorkSpaces from 'modules/space_control/components/WorkSpacesList/LoadingWorkSpaces'
import WorkSpaceCard from 'modules/space_control/components/WorkSpacesList/WorkSpaceCard'
import {
  WorkSpaceWithBookingNode,
  useWorkSpacesWithBookings,
} from 'modules/space_control/hooks/useWorkSpacesWithBookings'

interface Props {
  selectedWorkAreaId?: string
  selectedLocationId?: string
  queryVariables: GetWorkSpacesWithBookingsQueryVariables
}

const WorkSpacesList = ({ selectedWorkAreaId, selectedLocationId, queryVariables }: Props) => {
  const pageSize = 50
  const {
    workSpaces,
    controls: { loading, fetchMore, hasMore },
  } = useWorkSpacesWithBookings({ first: pageSize, ...queryVariables })

  if (loading) return <LoadingWorkSpaces />

  const groupedWorkSpaces = groupBy(workSpaces, function (workSpace: WorkSpaceWithBookingNode) {
    if (workSpace?.workArea?.location?.name && workSpace?.workArea?.name)
      return `${workSpace?.workArea.location.name}, ${workSpace?.workArea.name}`

    return ''
  })

  if (workSpaces && workSpaces.length < 1) {
    return (
      <EmptySpace
        workAreaId={selectedWorkAreaId ? selectedWorkAreaId : undefined}
        selectedLocationId={selectedLocationId ? selectedLocationId : undefined}
      />
    )
  }

  return (
    <Box flexGrow gap="s32">
      {Object.keys(groupedWorkSpaces).map((group_name, index, array) => {
        const isLastElement = index === array.length - 1
        const areaWorkSpaces = groupedWorkSpaces[group_name] ?? []
        const sortedWorkSpaces = areaWorkSpaces.sort((a, b) => Number(a.isFull) - Number(b.isFull))
        return (
          <InfiniteScroll
            key={group_name + '_work-spaces-list-infinite-scroll'}
            loadMore={fetchMore}
            hasMore={hasMore}
            loader={
              <Box flexGrow style={{ marginTop: '16px' }}>
                <LoadingWorkSpaces />
              </Box>
            }
            initialLoad={false}
            threshold={pageSize}
          >
            <Box key={group_name + '_work-spaces-list'} gap="s16">
              {!selectedWorkAreaId && (
                <Box gap="s8" flexDirection="row" alignItems="flexEnd">
                  <Text.Header2>{group_name}</Text.Header2>
                  <Text.Normal weight="medium">
                    {hasMore && isLastElement && '+'}
                    {i18n.tp('space_control.overview.spaces_count', {
                      count: areaWorkSpaces.length,
                    })}
                  </Text.Normal>
                </Box>
              )}
              <Grid component="ul" variant="medium">
                {map(sortedWorkSpaces, (workSpace: WorkSpaceWithBookingNode) => (
                  <WorkSpaceCard key={'workspace' + workSpace.workSpaceId} workSpace={workSpace} />
                ))}
              </Grid>
            </Box>
          </InfiniteScroll>
        )
      })}
    </Box>
  )
}

export default WorkSpacesList
